import { getGroupPermissionFactory, PermissionEnum } from '../../../../common';
import { getLocationManagementModuleName } from './location-management.permissions';

export class StatesPermissions {
    static GroupName = `${getLocationManagementModuleName()}.States`;

    static getPermissions = getGroupPermissionFactory(StatesPermissions.GroupName);

    static Permissions = {
        Create: StatesPermissions.getPermissions(PermissionEnum.CREATE),
        Read: StatesPermissions.getPermissions(PermissionEnum.READ),
        ReadAll: StatesPermissions.getPermissions(PermissionEnum.READ_ALL),
        Update: StatesPermissions.getPermissions(PermissionEnum.UPDATE)
    };
}
